module.exports = __webpack_public_path__ + "img/logo_wr.4a9ec58a.png";